import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2628f8f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-bg-[#FEE5E2] tw-px-[12px] tw-py-[8px] tw-flex tw-items-center tw-mt-[25px] tw-rounded-[6px] tw-gap-[10px]"
}
const _hoisted_2 = { class: "tw-text-[#F7553C] tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-text-center tw-mb-[0px]" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "tw-mb-[25px] tw-pt-[37px] tw-leading-[100%]" }
const _hoisted_5 = { class: "tw-text-[#231F20] tw-text-[14px] tw-font-medium" }

import { ref, computed, onMounted, watch, Ref } from "vue";
import ButtonAddAnother from "./buttonAddAnother.vue";
import { ensurePeriod, getComponentUiText } from "@/utils/utilities";
import WizardQuestion from "./wizardQuestion.vue";
import WizardRadioQuestion from "./wizardRadioQuestion.vue";
import store from "@/store";
import listBrand from "./listBrand.vue";
import WarningIcon from "../svgs/warningIcon.vue";
import { statusPage } from "@/utils/constants";

export default /*#__PURE__*/_defineComponent({
  __name: 'brandsPage',
  props: {
  isApiError: {
    type: Boolean,
    required: false,
    default: false,
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
},
  emits: [
  "onUpdate",
  "update:answer",
  "changeStatusAddBrand",
],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;

const currentOrg = computed(() => store.state.Org.currentOrg);
onMounted(() => {
  store.commit("SetupWizard/SET_CURRENT_ORG", currentOrg.value.id);
});

const listBrandRef: any = ref([]);

watch(
  props.statusInPage,
  (value) => {
    if (
      value.statusPage === statusPage.CallApi ||
      value.statusPage === statusPage.Error
    ) {
      brands.value = brands.value.map((item) => {
        item.isCallAPI = true;
        return item;
      });
    }
  },
  { deep: true },
);

const accordionNumber = computed(() => {
  const setupWizard = store.state.SetupWizard;
  if (
    setupWizard.questions[currentOrg.value.id]?.brands[0]?.values.length > 0
  ) {
    return setupWizard.questions[currentOrg.value.id].brands[0].values.map(
      (el) => ({
        ...el,
        showAccordion: false,
      }),
    );
  } else {
    return [];
  }
});
const brands: Ref<any> = ref(accordionNumber);
const isBrandName = computed(() => {
  const setupWizard = store.state.SetupWizard;
  if (setupWizard.questions[currentOrg.value.id]?.brands[0]?.values) {
    const isBrandName = setupWizard.questions[
      currentOrg.value.id
    ].brands[0].values.some((item) => item.id && !item.isArchived);
    return isBrandName ? 1 : "";
  } else {
    return "";
  }
});
const checkAllValidations = async () => {
  let isAllValid = true,
    listServices = [] as any[];
  for (let index = 0; index < listBrandRef.value.length; index++) {
    const test = await listBrandRef.value[index].saveChanges();
    if (!test) {
      isAllValid = false;
    }
    listServices.push(test.finalValue);
  }
  return isAllValid;
};

const currentValue = ref(0);
const checkYesNo = (value) => {
  currentValue.value = value;
  emits("onUpdate", value);
};

const addAnother = () => {
  const objAdd = {
    brandName: "",
    domainRegistrarId: null,
    domainRegistrar: null,
    startDate: new Date(),
    description: null,
    notes: null,
    endDate: null,
    showAccordion: false,
    isArchived: false,
  };
  accordionNumber.value.forEach((item) => (item.showAccordion = false));
  store.commit("SetupWizard/SET_BRAND_NAME_PUSH", {
    objAdd,
    currentOrg: currentOrg.value.id,
  });
};
__expose({
  checkAllValidations,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(WizardQuestion, {
      title: 
        _unref(getComponentUiText)(
          'app-component-wizards-setup-wizard-brands-page-title-1',
        )
      ,
      description: 
        _unref(getComponentUiText)(
          'app-component-wizards-setup-wizard-brands-page-sub-title-1',
        )
      
    }, {
      default: _withCtx(() => [
        _createVNode(WizardRadioQuestion, {
          title: 
          _unref(getComponentUiText)(
            'app-component-wizards-setup-wizard-brands-page-question-1',
          )
        ,
          required: true,
          answer: isBrandName.value,
          onOnUpdate: checkYesNo
        }, null, 8, ["title", "answer"]),
        (__props.isApiError && __props.statusInPage.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(WarningIcon, { color: "#F7553C" }),
              _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(getComponentUiText)(
              "app-component-wizards-setup-error-tooltip",
              false,
              {
                errorMessage: __props.statusInPage.errorMessage
                  ? _unref(ensurePeriod)(__props.statusInPage.errorMessage)
                  : "",
              },
            )), 1)
            ]))
          : _createCommentVNode("", true),
        (currentValue.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)(
              "app-menu-submenu-home-setup-wizard-brand-details-note-1",
            )), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brands.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id
                }, [
                  _createVNode(listBrand, {
                    ref_for: true,
                    ref_key: "listBrandRef",
                    ref: listBrandRef,
                    item: item,
                    "current-index": index,
                    data: { item: item, index: index },
                    "status-in-page": __props.statusInPage,
                    onChangeStatusAddBrand: _cache[0] || (_cache[0] = ($event: any) => (
              emits('onUpdate', $event), checkAllValidations
            ))
                  }, null, 8, ["item", "current-index", "data", "status-in-page"])
                ]))
              }), 128)),
              _createVNode(ButtonAddAnother, {
                "style-button": "tw-mt-0",
                onClick: addAnother
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-menu-submenu-home-setup-wizard-brand-add-another-button-1",
            )), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "description"])
  ]))
}
}

})